import { MainLayout } from '@design-system/Layout';
import React, { useEffect, useState } from 'react';
import { Container, Card, OrderSummary, Summary } from './style';
import { Link } from 'react-router-dom';
import basket from '@design-system/Assets/order_success.png';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOrderHistory } from '@app/orderHistory/redux/selectors';
import { useDispatch } from 'react-redux';
import { get_orders } from '@app/orderHistory/redux/reducer';
import commaNumber from 'comma-number';

const OrderSuccess = () => {
  const params = useParams();
  const order = useSelector(getOrderHistory);
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [remainingItems, setRemainingItems] = useState(0);

  useEffect(() => {
    dispatch(get_orders(params.id));
  }, [dispatch, params]);

  useEffect(() => {
    const slicedArray = order?.products?.slice(0, 4);
    setProducts(slicedArray);
    setRemainingItems(order?.products?.length - slicedArray?.length);
  }, [order]);

  return (
    <MainLayout>
      <Container>
        <Card>
          <div>
            <div className="image">
              <img src={basket} alt="basket" />
            </div>

            <p className="title">Thank you for your purchase!</p>
            <p className="sub_title">We are sending order confirmation to:</p>
            <p className="email">{order?.created_by?.email}</p>

            <p className="order_no">Your order number is:</p>
            <p className="transaction">{order?.order_no}</p>

            <OrderSummary>
              <div className="title">Order Summary</div>
              <div className="product">
                <div className="product_container">
                  {products?.map((data, idx) => (
                    <img src={data.product.image} key={idx} />
                  ))}

                  {remainingItems >= 1 && (
                    <div className="other_box">+{remainingItems}</div>
                  )}
                </div>
              </div>
            </OrderSummary>

            <Summary>
              <div className="left">Store Details</div>
              <div className="right">{order?.partner?.phone}</div>
            </Summary>
            <Summary>
              <div className="left">Total</div>
              <div className="right">
                {order?.amount_paid?.currency.symbol}
                {commaNumber(order?.amount_paid?.value)}
              </div>
            </Summary>

            <Link
              to={`/sella/${order?.partner?.business_name}`}
              style={{
                textDecoration: 'none',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <p className="link">Continue Shopping</p>
            </Link>
          </div>
        </Card>
      </Container>
    </MainLayout>
  );
};

export default OrderSuccess;
